import './receipt.scss'

import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import _ from 'lodash'
import Receipt from './Receipt'
import { resetCheckout } from '../../actions/checkout-actions'
import { resetOrder } from '../../actions/order-actions'
import { CATEGORIES } from '../products/product-constants'

const mapStateToProps = (state, ownProps) => {
    if (!state.checkout.completed) ownProps.history.replace('/');
    return {
        appLocale: state.app.locale,
        receipt: state.checkout.receipt || { checkout: {}, vouchers: [] },
        showPrice: state.order.product.category == CATEGORIES.GIFTCARD,
        isCinemaxx: state.webshop.organizer.id == 160,
        customerName: state.checkout.customer.name || "",
        organizer: state.webshop.organizer,
        salesChannel: state.webshop.salesChannel ? `&saleschannel=${state.webshop.salesChannel}` : '',
        additionalHtml: state.webshop.receiptHtml
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        actions: bindActionCreators({ resetCheckout, resetOrder }, dispatch)
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Receipt)